import { ApiUrl } from "@/utils/url/api-url";
export const currentUser = window.CURRENT_USER;

export const currentUserId = currentUser?.id;

// Каждая webpack-точка входа собирает свою копию этого модуля, поэтому без общего
// кэша каждый бандл заново запрашивает user/folders при инициализации. Кэшируем
// промис на window (как FoquzEvent / GUEST_FOLDERS), чтобы все бандлы использовали один запрос.
export function getUserFolders() {
  if (!window.__userFoldersPromise) {
    window.__userFoldersPromise = fetch(ApiUrl("user/folders")).then(
      (response) => response.json()
    );
  }
  return window.__userFoldersPromise;
}

// Перезапрашивает user/folders, обновляя общий кэш. Копии этого модуля из разных
// бандлов могут дёрнуть refresh одновременно (по одному window-событию), поэтому
// летящий запрос тоже общий — один на все бандлы.
export function refreshUserFolders() {
  if (!window.__userFoldersRefreshPromise) {
    const promise = fetch(ApiUrl("user/folders"))
      .then((response) => response.json())
      .finally(() => {
        if (window.__userFoldersRefreshPromise === promise) {
          window.__userFoldersRefreshPromise = null;
        }
      });
    window.__userFoldersRefreshPromise = promise;
    window.__userFoldersPromise = promise;
  }
  return window.__userFoldersRefreshPromise;
}
